<template>
  <b-form @submit.prevent="submit()" class="faq-search-box">
    <label for="query" v-if="isIE">{{ searchFaqTitle }}</label>
    <b-input-group label="" label-for="query" class="faq-search-form">
      <div data-for="query" class="placeholder-label">{{ searchFaqTitle }}</div>
      <b-input-group-prepend>
        <font-awesome-icon :icon="['fas', 'search']" class="footer_btn"></font-awesome-icon>
      </b-input-group-prepend>
      <b-form-input id="query" type="text" v-model.trim="searchQuery" :placeholder="searchFaqTitle"
                    class="customer faq-search" autocomplete="off" required maxlength="255">
      </b-form-input>
      <b-input-group-append>
        <b-button block type="button" class="btn btn-default btn-account" variant="primary" @click.prevent.stop="submit()">
          Search
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'FaqSearchBox',
  data: function() {
    return {
      searchQuery: '',
      searchFaqTitle: 'Search by topics, keywords or phrases'
    }
  },
  computed: {
    ...mapState(['isIE'])
  },
  methods: {
    submit: function() {
      this.$router.replace({name: 'faq-search', query: {q: encodeURIComponent(this.searchQuery)}})
    }
  },
  created() {
    if (window.innerWidth <= 576) {
      this.searchFaqTitle = 'Search keywords or topics'
    }
  }
}
</script>

<style scoped lang="less">
  .faq-search-box {
    .input-group-prepend {
      position: absolute;
      z-index: 4;
      top: 15px;
      left: 10px;
      color: var(--theme_color);
    }
    .faq-search {
      padding-left: 35px;
    }
    .footer_btn{
      font-size: 20px;
    }
    .btn-account {
      font-size: 18px;
      font-weight: 600;
    }
  }

</style>
